import React from 'react';
const stats = [{
  value: '574',
  label: 'Users'
}, {
  value: '97%',
  label: 'Multi-stop plans'
}, {
  value: '59%',
  label: 'Return rate'
}, {
  value: '25',
  label: 'Cities · 4 continents'
}];
export function GrowthSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-229">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden justify-center" data-id="element-230">
        {/* Header */}
        <div className="flex-shrink-0 flex flex-col items-center text-center" style={{
        padding: '0 clamp(2rem, 6vw, 6rem)',
        marginBottom: 'clamp(2rem, 4vw, 3.5rem)'
      }} data-id="element-231">
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.25rem, 0.5vw, 0.4rem)',
          animationDelay: '0.1s'
        }} data-id="element-232">
            With no robust engagement mechanism.
          </p>
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.15s'
        }} data-id="element-233">
            Already seeing strong usage signals.
          </h1>
        </div>

        {/* Hero Stat */}
        <div className="flex-shrink-0 flex flex-col items-center text-center animate-fade-slide" style={{
        padding: '0 clamp(2rem, 6vw, 6rem)',
        marginBottom: 'clamp(2.5rem, 5vw, 4rem)',
        animationDelay: '0.25s'
      }} data-id="element-234">
          <span className="font-black" style={{
          color: '#4A90D9',
          fontSize: 'clamp(3rem, 10vw, 8rem)',
          lineHeight: '1',
          letterSpacing: '-0.03em',
          marginBottom: 'clamp(0.5rem, 1vw, 1rem)'
        }} data-id="element-235">
            25,174
          </span>
          <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: 'clamp(0.85rem, 1.6vw, 1.2rem)',
          lineHeight: '1.5',
          maxWidth: 'clamp(300px, 50vw, 550px)'
        }} data-id="element-236">
            times Navi understood what someone wanted
            <br data-id="element-237" />— and did something about it.
          </p>
        </div>

        {/* Stat Strip */}
        <div className="flex-shrink-0 flex items-center justify-center w-full animate-fade-slide" style={{
        padding: '0 clamp(2rem, 6vw, 6rem)',
        animationDelay: '0.4s'
      }} data-id="element-238">
          <div className="w-full max-w-2xl flex items-start justify-between" style={{
          gap: 'clamp(0.5rem, 1vw, 1rem)'
        }} data-id="element-239">
            {stats.map((s, i) => <div key={s.label} className="flex flex-col items-center text-center flex-1" style={{
            borderLeft: i > 0 ? '1px solid rgba(255,255,255,0.08)' : 'none',
            paddingLeft: i > 0 ? 'clamp(0.5rem, 1vw, 1rem)' : '0'
          }} data-id="element-240">
                <span className="font-black" style={{
              color: '#ffffff',
              fontSize: 'clamp(1.1rem, 2.2vw, 1.8rem)',
              lineHeight: '1.1',
              marginBottom: 'clamp(0.15rem, 0.3vw, 0.25rem)'
            }} data-id="element-241">
                  {s.value}
                </span>
                <span style={{
              color: 'rgba(255,255,255,0.35)',
              fontSize: 'clamp(0.55rem, 0.85vw, 0.75rem)',
              lineHeight: '1.3'
            }} data-id="element-242">
                  {s.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}